import TableOfContents from './TableOfContentsComponent';

globalThis.TableOfContentsComponents = {
  TableOfContents,
};
